import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { Button } from '@bphxd/ds-core-react';
import { Alert16 } from '@bphxd/ds-core-react/lib/icons';
import { TPermitWithJobDetails } from '../../../lib/types';

const PermitDetailsModal: React.FC<{
  permit: TPermitWithJobDetails | null;
  onClose: () => void;
}> = ({ permit, onClose }) => {
  if (!permit) return null;

  const isTaskDescriptionMismatch = permit.lastKnownTaskDescription !== permit.taskDescription;

  return (
    <Modal isOpen={!!permit} toggle={onClose}>
      <ModalHeader toggle={onClose}>Permit Details</ModalHeader>
      <ModalBody>
        <p>
          <strong>Mo Number:</strong> {permit.moNumber}
        </p>
        <p>
          <strong>Task Id:</strong> {permit.taskId}
        </p>
        <p className="d-flex align-items-center gap-2">
          <strong>Last Known Task Description:</strong>
          {permit.lastKnownTaskDescription}
          {isTaskDescriptionMismatch && <Alert16 style={{ marginLeft: '4px' }} />}
        </p>
        <p>
          <strong>Current SAP Task Description:</strong> {permit.taskDescription}
        </p>
        <p>
          <strong>Permit Number:</strong> {permit.permitNumber}
        </p>
      </ModalBody>
      <ModalFooter>
        <Button level="tertiary" onClick={onClose}>
          Close
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default PermitDetailsModal;
